import type { FC } from "react";
import { useSelector } from "react-redux";

import { Dialog, DialogContent } from "@/components/ui/dialog";
import { TooltipProvider } from "@/components/ui/tooltip";

import { lawyerSelectors } from "../../../redux/lawyer/selectors";
import type { LawyerReducer } from "../../../redux/lawyer/lawyerSlice";
import { ForeignNationalsProvider } from "../../foreignNationals/context/ForeignNationalsContext";
import { NewClientWizard } from "./NewClientWizard";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onCreated: (uid: string) => void;
  /** Remounts the form so each open starts fresh. */
  session?: number | string;
};

/** New Client in the same 640px create modal as New Case. */
export const NewClientDialog: FC<Props> = ({
  open,
  onOpenChange,
  onCreated,
  session
}) => {
  const firmName = useSelector((s: LawyerReducer) =>
    lawyerSelectors.selectPracticeName(s)
  );

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        showCloseButton={false}
        aria-describedby={undefined}
        onOpenAutoFocus={(event) => event.preventDefault()}
        className="top-16 flex max-h-[calc(100vh-8rem)] translate-y-0 flex-col gap-0 overflow-hidden bg-elevated p-0 sm:max-w-160"
      >
        <TooltipProvider>
          <ForeignNationalsProvider mode="self">
            <NewClientWizard
              key={session ?? ""}
              firmName={firmName || null}
              onCancel={() => onOpenChange(false)}
              onCreated={onCreated}
            />
          </ForeignNationalsProvider>
        </TooltipProvider>
      </DialogContent>
    </Dialog>
  );
};
